module.exports = __webpack_public_path__ + "static/Physical-e799906b6d57b8356f41ccb819eedc9d.png";